export default __webpack_public_path__ + "static/media/MiniTape_SideB_03_Schützenfest2.9ae32664.mp3";